
<template>
  <div class="externalTransaction-tab">
    <ExternalTransactionRecordTable
      v-loading="loading.table"
      :tableData="tableData"
      :enableColumns="['customerProfile', 'branchName']"
      :externalData="{ cyjPosBranchList, cyjPosEnabled }"
      :options="{
        showBranch: false,
        showPhone: false,
      }"
      @refresh="refresh(false)"
    />
    <Pagination
      :curPage.sync="tableOptions.page"
      :pageLimit="tableOptions.pageLimit"
      :total="tableDataCount"
      @pageChange="refresh(false)"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import { GetCustomModule } from '@/api/customModule'
import { useShop } from '@/use/shop'
import { computed, onMounted, onActivated, defineComponent, ref } from 'vue'
import { useTable } from '@/use/table'
import { GetMemberExternalTransaction, GetMemberExternalTransactionCount } from '@/api/memberExternalTransaction'
import { GetCyjPosBranches } from '@/api/cyjPos'
import ExternalTransactionRecordTable from '@/components/ExternalTransaction/ExternalTransactionRecordTable.vue'
import { useFetch } from '@/use/fetch'
import { usePermissions } from '@/use/permissions'

export default defineComponent({
  name: 'ExternalTransactionTab',
  components: {
    ExternalTransactionRecordTable,
  },
  props: ['member'],
  setup (props, { emit }) {
    const { simpleFetch } = useFetch()
    const { checkAction } = usePermissions()
    const {
      tableData,
      tableOptions,
      tableDataCount,
      loading,
      pageStartIndex,
      fetchData,
      fetchDataCount,
    } = useTable()
    const { shopId } = useShop()
    const cyjPosBranchList = ref([])
    const cyjPosModule = ref(null)
    const cyjPosEnabled = computed(() => checkAction('planModule.cyjPos.enable'))

    const getTableData = async () => {
      const payload = {
        MemberId: get(props.member, 'id', undefined),
        shopId: shopId.value,
        start: pageStartIndex.value,
        limit: tableOptions.pageLimit,
      }
      await Promise.allSettled([
        fetchData(GetMemberExternalTransaction, payload),
        fetchDataCount(GetMemberExternalTransactionCount, payload),
      ])
    }
    const getCyjPosModule = async () => {
      const res = await simpleFetch(GetCustomModule, {
        shopId: shopId.value,
        type: 'cyjPos',
      })
      cyjPosModule.value = Array.isArray(res) ? res[0] : null
    }
    const getCyjPosBranchList = async () => {
      if (!cyjPosEnabled.value) {
        cyjPosBranchList.value = []
        return
      }
      const res = await simpleFetch(GetCyjPosBranches, { shopId: shopId.value })
      cyjPosBranchList.value = res === 'error'
        ? []
        : get(res, 'branches', [])
    }
    const refresh = async (search = false) => {
      if (search) tableOptions.page = 1
      loading.table = true
      await getTableData()
      loading.table = false
    }
    onMounted(async () => {
      await getCyjPosModule()
      await Promise.allSettled([
        refresh(),
        getCyjPosBranchList(),
      ])
    })
    onActivated(async () => {
      if (!cyjPosModule.value) {
        await getCyjPosModule()
      }
      if (cyjPosEnabled.value && !cyjPosBranchList.value.length) {
        await getCyjPosBranchList()
      }
      await refresh()
    })
    return {
      cyjPosBranchList,
      cyjPosEnabled,
      tableData,
      tableOptions,
      tableDataCount,
      loading,
      refresh,
    }
  },
})
</script>

<style scoped lang="scss">
</style>
